module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.88d386a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/title-banner1-type3.png
// module id = UT0F
// module chunks = 1